interface KpiCardProps {
  label: string;
  value: string;
  sub?: string;
  icon: string;
  tone?: 'primary' | 'accent' | 'secondary' | 'dark';
  onClick?: () => void;
}

const toneClasses: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-700',
  dark: 'bg-foreground-900 text-foreground-50',
};

export default function KpiCard({ label, value, sub, icon, tone = 'primary', onClick }: KpiCardProps) {
  return (
    <div
      onClick={onClick}
      className={`rounded-lg border border-background-200 bg-background-50 p-4 transition-colors ${
        onClick ? 'cursor-pointer hover:border-primary-300 hover:bg-background-100/60' : ''
      }`}
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wide text-foreground-500">{label}</p>
          <p className="mt-2 font-heading text-2xl font-semibold text-foreground-950">{value}</p>
          {sub && <p className="mt-1 text-xs text-foreground-500">{sub}</p>}
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${toneClasses[tone]}`}>
          <i className={`${icon} text-lg`} />
        </div>
      </div>
    </div>
  );
}